@if (activeQuestion()) {
  @if (choiceQuestionTypes.includes(activeQuestion().get('type').value)) {
    <eiq-break-line></eiq-break-line>

    <div class="choice-settings__title">
      <span class="fs__lg fw__500">Autopopulate</span>
    </div>
    <div>
      <mat-slide-toggle
        [labelPosition]="'before'"
        [color]="'primary'"
        [formControl]="activeQuestion().get('optionsSettings').get('autopopulateInd') | toFormControl"
        [checked]="activeQuestion().value.optionsSettings.autopopulateInd"
        [disabled]="!activeQuestion().get('requiredInd').value"
      >
        Automatically fills answer if there's only one option available to choose from.
      </mat-slide-toggle>
    </div>

    <eiq-break-line></eiq-break-line>
  }

  <div [formGroup]="activeQuestion()" class="choice-settings">
    <div class="choice-settings__title">
      <span class="fs__lg fw__500">Choices</span>
      <span class="fs__md caption">
        The left value serves as the Choice Id and it is used in logical rules and is the value submitted as an answer value. The right text is displayed to the
        participants
      </span>
    </div>
    <div formArrayName="options" class="choice-settings__table">
      <div class="choice-settings__header-row fs__md fw__500">
        <span>Value</span>
        <span>Text</span>
      </div>
      @for (optionCtrl of (activeQuestion().get('options') | toFormArray).controls; track $index) {
        <div [formGroupName]="$index" class="choice-settings__edit-row">
          <mat-form-field appearance="outline"> <input matInput formControlName="value" autocomplete="off" [value]="optionCtrl.value.value" /> </mat-form-field>
          <mat-form-field appearance="outline"> <input matInput [disabled]="true" [value]="optionCtrl.value.text | toPlainText" /> </mat-form-field>
        </div>
      }
    </div>
  </div>
}

@if (questionsToCopyOptionsAnswersFrom.length > 0) {
  <eiq-break-line></eiq-break-line>

  <div class="choice-settings__question-selector">
    <div class="choice-settings__question-select">
      <span class="fs__lg fw__500">Copy selected options from:</span>

      <mat-radio-group aria-label="Select an option" class="choice-settings__question-select__radio-group" (change)="onSetOptionsExclusion($event.value)">
        @for (option of copyOptionsExclusionLevelOptions; track option.value) {
          <mat-radio-button color="primary" [checked]="option.value === questionToCopyExclusionLevel.value" [value]="option.value">
            <div>
              <span class="fs__sm fw__500">{{ option.text }}</span>
            </div>
          </mat-radio-button>
        }
      </mat-radio-group>

      <mat-form-field appearance="outline">
        <mat-select [formControl]="questionToCopyOptionsAnswersFromCtrl">
          @for (question of questionsToCopyOptionsAnswersFrom; track question.id) {
            <mat-option [value]="question.id">{{ question.code }} - {{ question.title | toPlainText }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>
}

@if (questionsToCopyOptionsFrom.length > 0) {
  <eiq-break-line></eiq-break-line>

  <div class="choice-settings__question-selector">
    <div class="choice-settings__question-select">
      <span class="fs__lg fw__500">Copy options from:</span>
      <mat-form-field appearance="outline">
        <mat-select [formControl]="questionToCopyFromCtrl">
          @for (question of questionsToCopyOptionsFrom; track question.id) {
            <mat-option [value]="question.id">{{ question.code }} - {{ question.title | toPlainText }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>
}
